import type { SpinProps } from 'antd';
import type { PropsWithChildren } from 'react';
import { Suspense } from 'react';

export interface LazyWrapperProps extends PropsWithChildren {
  spinProps?: SpinProps;
}

export default function LazyWrapper({ children }: LazyWrapperProps) {
  return <Suspense fallback={<Spin></Spin>}>{children}</Suspense>;
}
